export enum Role {
  Admin = "Admin",
  Candidate = "Candidate",
  Unauthorized = "Unauthorized",
}
